module.exports = __webpack_public_path__ + "media/components/country-flag/static/sc-13fd7260d5f112a180257983b441246f.svg";